@if (isVisible() && message()) {
  <div class="countdown" [class.rounded-btm]="roundedBtm()">
    {{ message() }}
  </div>
}